/* tslint:disable */
/* eslint-disable */
/**
 * Melco Fusion APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FusionMelcoFusionModelsCustomProductDesignCollection
 */
export interface FusionMelcoFusionModelsCustomProductDesignCollection {
    /**
     * 
     * @type {string}
     * @memberof FusionMelcoFusionModelsCustomProductDesignCollection
     */
    id?: string | null;
}

export function FusionMelcoFusionModelsCustomProductDesignCollectionFromJSON(json: any): FusionMelcoFusionModelsCustomProductDesignCollection {
    return FusionMelcoFusionModelsCustomProductDesignCollectionFromJSONTyped(json, false);
}

export function FusionMelcoFusionModelsCustomProductDesignCollectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): FusionMelcoFusionModelsCustomProductDesignCollection {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
    };
}

export function FusionMelcoFusionModelsCustomProductDesignCollectionToJSON(value?: FusionMelcoFusionModelsCustomProductDesignCollection | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}


